export const DEFAULT_LANGUAGE = 'en'
export const FALLBACK_LANGUAGE = 'en'
export const SUPPORTED_LANGUAGES = ['en', 'zh-hk']
export const SUPPORTED_LANGUAGES_MAPPING = {
  en: 'EN',
  'zh-hk': '繁'
}
